module.exports = __webpack_public_path__ + "static/media/google.0dd54f85.png";